import React from 'react'
import {Container} from 'react-bootstrap'
import Breadcrumb from 'components/breadcrumb/breadcrumb'
import CoverImg from 'components/General/CoverImg'
import culture from "../../assets/img/culture.jpg"

const IdentificationPage = () => {
  return (
    <>
    <CoverImg img={culture}/>
    <Breadcrumb/>
    <Container>
        <div className="arc-en-ciel mb-5">
        <div data-module="student" data-action="reminder" data-param-login-url="/connexion" className='reminder-form'></div>
        </div>
    </Container>
    </>
  )
    
}

export default IdentificationPage